import React, { useEffect, useState } from "react";
import api from "../../api";
import { Megaphone, Trophy } from "lucide-react";
import { CampaignChart } from "./CampaignChart";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");

export const PromoPerformance = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/business/promo-campaigns").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  if (!rows) return null;
  return (
    <div className="bg-white rounded-2xl p-6 shadow-[0_8px_24px_rgba(20,30,55,0.06)] mb-8" data-testid="promo-performance">
      <h3 className="font-semibold text-[#16243b] flex items-center gap-2"><Megaphone size={18} className="text-[#2ec9c9]" /> Promo performance</h3>
      <p className="text-sm text-[#8a97a8] mb-4">Every promo banner you run is tracked as a campaign, ranked by revenue. Sales count when the campaign's code was used during its dates (or all sales, if no code).</p>
      {rows.length === 0 ? (
        <p className="text-sm text-[#8a97a8] py-6 text-center" data-testid="promo-performance-empty">No campaigns yet. Switch on a promo banner in the Storefront tab to start tracking.</p>
      ) : (
        <>
        <CampaignChart rows={rows} />
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-[#8a97a8]"><tr>{["Campaign", "Dates", "Sold", "Revenue", "Discount given", "Avg order"].map((h) => <th key={h} className="text-left px-3 py-2 font-medium">{h}</th>)}</tr></thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.id} className="border-t border-gray-50" data-testid={`campaign-row-${i}`}>
                  <td className="px-3 py-3">
                    <span className="font-medium text-[#16243b] flex items-center gap-1.5">{i === 0 && r.revenue > 0 && <Trophy size={14} className="text-amber-500" />}{r.name}</span>
                    <span className="text-xs text-[#8a97a8]">{r.code ? <span className="font-mono">{r.code}</span> : "No code"}{r.live && <span className="ml-2 rounded-full bg-[#dcfce7] text-[#166534] px-2 py-0.5">Live</span>}</span>
                  </td>
                  <td className="px-3 py-3 text-[#5a6b80] whitespace-nowrap">{fmtDate(r.started_at)} – {r.ended_at ? fmtDate(r.ended_at) : r.ends_at ? fmtDate(r.ends_at) : "ongoing"}</td>
                  <td className="px-3 py-3 text-[#16243b]" data-testid={`campaign-sold-${i}`}>{r.sold}</td>
                  <td className="px-3 py-3 font-semibold text-[#16243b]" data-testid={`campaign-revenue-${i}`}>£{r.revenue.toFixed(2)}</td>
                  <td className="px-3 py-3 text-[#5a6b80]">£{r.discount_given.toFixed(2)}</td>
                  <td className="px-3 py-3 text-[#5a6b80]">£{r.avg_order.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        </>
      )}
    </div>
  );
};
